import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	descriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-zero.description-non-final',
		defaultMessage: `Your contact methods, notification and forwarding rules from Opsgenie are now synced with Jira Service Management, without any changes.

You'll continue to get your alert and on-call notifications as usual, but they will now be sent by Jira Service Management and not Opsgenie. Update your filters and blocklist in your email client to ensure that you have access to email notifications from '<BlueText>'no-reply@jsm-notifications.atlassian.net'</BlueText>'.

To manage your alert notification settings, go to **Personal settings** and select Alerts in **Notification settings**.`,
		description:
			'Description of the notifications step cards inside notifications onboarding step in markdown format.',
	},
	manageYourAlertNotificationsNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-zero.manage-your-alert-notifications-non-final',
		defaultMessage: 'Manage your alert notifications',
		description: 'Button text to manage alert notifications',
	},
});
